import {
  ClsPeticionConsultarGralsCatalogos,
  ClsPeticionEliminarGralsCatalogos,
  ClsPeticionRegistraActualizaGralsCatalogos,
  ClsRespuestaRegistraActualizaGralsCatalogos
} from '../../core/models/peticiones/catalogos/cls-pr-catalogos';
import {ClsUtil} from '../../util/cls-util';
import {GenericoService} from '../../core/services/generico.service';
import {AppPresupuestosService} from '../../core/services/app-presupuestos.service';
import {AppInfoService} from '../../core/services/app-info.service';
import {ClsConfig} from '../../util/cls-config';
import {EnumMCGenerales} from '../../core/models/enum/enum-menu-contextual';
import {IMenuOpcionesCatalogos, INeodataMenu} from '../../core/models/interfaces/generico-interface';
import {EnumTresPuntos} from '../../core/models/enum/enum-tres-puntos';
import {ClsObjGenerico} from '../util/cls-obj-generico';
import {ClsCalendario, ClsCalendarioFecha} from "../../core/models/cls-catalogos";
import {ClsErrores} from "../../core/models/cls-errores";
import {inject} from "@angular/core";
import {EnumMasOpciones} from "../../core/models/enum/enum-mas-opciones";
import {ClsRecibirProgramas} from "../../core/models/peticiones/cls-pr-programa";

export class ClsObjCrudCatalogos extends ClsConfig {
  public dataCatalogo: any[] = [];
  private offset: number;
  // menu contextual
  private menus: INeodataMenu[] = [];

  private infPpto = inject(AppPresupuestosService);
  private servicioGen = inject(GenericoService);
  private infApp = inject(AppInfoService);

  constructor() {
    super();
  }

  public crearMenuContextual(opciones: IMenuOpcionesCatalogos, esMaestro: boolean) {
    let opcAdicionales: INeodataMenu;
    this.menus = [];
    const subLayout: INeodataMenu[] = [
      {
        id: EnumMasOpciones.Ajustar,
        descripcion: 'MENUCONTEXTUAL.ALTO_FILA',
        icono: 'wrap_text',
        disabled: false,
        divisor: true
      },
      {
        id: EnumMCGenerales.GuardarLayout,
        descripcion: 'MENUCONTEXTUAL.GUARDAR_LAYOUT',
        icono: 'save',
        disabled: false,
        divisor: false
      },
      {
        id: EnumMCGenerales.ReestablecerLayout,
        descripcion: 'MENUCONTEXTUAL.RESTABLECER_LAYOUT',
        icono: 'restore',
        disabled: false,
        divisor: false
      }
    ];
    if (opciones.esUnidad) {
      opcAdicionales = {
        id: EnumMCGenerales.UnificarUnidades,
        descripcion: 'MENUCONTEXTUAL.UNIFICAR',
        icono: '',
        disabled: esMaestro,
        divisor: true
      };
      // this.menus.push(opcAdicionales);
    }

    if (opciones.esEmpresa) {
      opcAdicionales = {
        id: EnumMCGenerales.DetalleEmpresa,
        descripcion: 'MENUCONTEXTUAL.DETALLE',
        icono: '',
        disabled: esMaestro,
        divisor: true
      };
      this.menus.push(opcAdicionales);
    }

    if (opciones.esCliente) {
      opcAdicionales = {
        id: EnumMCGenerales.ContactoCliente,
        descripcion: 'MENUCONTEXTUAL.CONTACTO_CLIENTE',
        icono: 'contacts',
        disabled: esMaestro,
        divisor: true
      };
      this.menus.push(opcAdicionales);
    }

    this.menus.push({
      id: EnumMCGenerales.Copiar,
      descripcion: 'MENUCONTEXTUAL.COPIAR',
      icono: 'content_copy',
      disabled: esMaestro,
      divisor: false
    });
    this.menus.push({
      id: EnumMCGenerales.Pegar,
      descripcion: 'MENUCONTEXTUAL.PEGAR',
      icono: 'content_paste',
      disabled: esMaestro,
      divisor: true
    });
    this.menus.push({
      id: '_layout',
      descripcion: 'MENUCONTEXTUAL.LAYOUT',
      icono: 'grid_on',
      disabled: false,
      divisor: true,
      subMenu: subLayout
    });
    return this.menus;
  }

  public validarSiCambioCamposCatalogos(newValor: any, oldValor: any, cat: EnumTresPuntos): boolean {
    let cambio = false;
    switch (cat) {
      case EnumTresPuntos.Ciudades:
        if (newValor.Ciudad !== oldValor.Ciudad) {
          cambio = true;
        }
        if (newValor.DescripcionCiudad !== oldValor.DescripcionCiudad) {
          cambio = true;
        }
        if (newValor.IdEstado !== oldValor.IdEstado) {
          cambio = true;
        }
        break;
      case EnumTresPuntos.Clientes:
        if (newValor.Cliente !== oldValor.Cliente) {
          cambio = true;
        }
        if (newValor.NombreCliente !== oldValor.NombreCliente) {
          cambio = true;
        }
        if (newValor.ColoniaCliente !== oldValor.ColoniaCliente) {
          cambio = true;
        }
        if (newValor.DireccionCliente !== oldValor.DireccionCliente) {
          cambio = true;
        }
        if (newValor.IdCiudadCliente !== oldValor.IdCiudadCliente) {
          cambio = true;
        }
        if (newValor.CodigoPostalCliente !== oldValor.CodigoPostalCliente) {
          cambio = true;
        }
        if (newValor.TelefonoCliente !== oldValor.TelefonoCliente) {
          cambio = true;
        }
        if (newValor.MailCliente !== oldValor.MailCliente) {
          cambio = true;
        }
        break;
      case EnumTresPuntos.ContactoCliente:
        // if (newValor.IdCliente !== oldValor.IdCliente) {
        //   cambio = true;
        // }
        if (newValor.NombreClienteContacto !== oldValor.NombreClienteContacto) {
          cambio = true;
        }
        if (newValor.CargoClienteContacto !== oldValor.CargoClienteContacto) {
          cambio = true;
        }
        if (newValor.TelefonoClienteContacto !== oldValor.TelefonoClienteContacto) {
          cambio = true;
        }
        if (newValor.MailClienteContacto !== oldValor.MailClienteContacto) {
          cambio = true;
        }
        break;
      case EnumTresPuntos.Empresas:
        if (newValor.Empresa !== oldValor.Empresa) {
          cambio = true;
        }
        if (newValor.RazonSocialEmpresa !== oldValor.RazonSocialEmpresa) {
          cambio = true;
        }
        if (newValor.IdCiudadEmpresa !== oldValor.IdCiudadEmpresa) {
          cambio = true;
        }
        if (newValor.DireccionEmpresa !== oldValor.DireccionEmpresa) {
          cambio = true;
        }
        if (newValor.Colonia !== oldValor.Colonia) {
          cambio = true;
        }
        if (newValor.IdResponsableEmpresa !== oldValor.IdResponsableEmpresa) {
          cambio = true;
        }
        if (newValor.TelefonoEmpresa !== oldValor.TelefonoEmpresa) {
          cambio = true;
        }
        if (newValor.MailEmpresa !== oldValor.MailEmpresa) {
          cambio = true;
        }
        if (newValor.IMSSEmpresa !== oldValor.IMSSEmpresa) {
          cambio = true;
        }
        if (newValor.CMICEmpresa !== oldValor.CMICEmpresa) {
          cambio = true;
        }
        if (newValor.InfonavitEmpresa !== oldValor.InfonavitEmpresa) {
          cambio = true;
        }
        if (newValor.FaxEmpresa !== oldValor.FaxEmpresa) {
          cambio = true;
        }
        if (newValor.RfcEmpresa !== oldValor.RfcEmpresa) {
          cambio = true;
        }
        if (newValor.CodigoPostalEmpresa !== oldValor.CodigoPostalEmpresa) {
          cambio = true;
        }
        if (newValor.SitioWeb !== oldValor.SitioWeb) {
          cambio = true;
        }
        break;
      case EnumTresPuntos.Estados:
        if (newValor.Estado !== oldValor.Estado) {
          cambio = true;
        }
        if (newValor.NombreEstado !== oldValor.NombreEstado) {
          cambio = true;
        }
        break;
      case EnumTresPuntos.Familias:
        if (newValor.Familia !== oldValor.Familia) {
          cambio = true;
        }
        if (newValor.DescripcionFamilia !== oldValor.DescripcionFamilia) {
          cambio = true;
        }
        break;
      case EnumTresPuntos.Proveedores:
        if (newValor.Proveedor !== oldValor.Proveedor) {
          cambio = true;
        }
        if (newValor.CelularProveedor !== oldValor.CelularProveedor) {
          cambio = true;
        }
        if (newValor.CodigoPostalProveedor !== oldValor.CodigoPostalProveedor) {
          cambio = true;
        }
        if (newValor.ColoniaProveedor !== oldValor.ColoniaProveedor) {
          cambio = true;
        }
        if (newValor.ContactoProveedor !== oldValor.ContactoProveedor) {
          cambio = true;
        }
        if (newValor.DireccionProveedor !== oldValor.DireccionProveedor) {
          cambio = true;
        }
        if (newValor.FaxProveedor !== oldValor.FaxProveedor) {
          cambio = true;
        }
        if (newValor.IdCiudad !== oldValor.IdCiudad) {
          cambio = true;
        }
        if (newValor.MailProveedor !== oldValor.MailProveedor) {
          cambio = true;
        }
        if (newValor.ObservacionesProveedor !== oldValor.ObservacionesProveedor) {
          cambio = true;
        }
        if (newValor.PaginaWebProveedor !== oldValor.PaginaWebProveedor) {
          cambio = true;
        }
        if (newValor.ProveedorDefault !== oldValor.ProveedorDefault) {
          cambio = true;
        }
        if (newValor.RazonSocial !== oldValor.RazonSocial) {
          cambio = true;
        }
        if (newValor.RfcProveedor !== oldValor.RfcProveedor) {
          cambio = true;
        }
        if (newValor.TelefonoProveedor !== oldValor.TelefonoProveedor) {
          cambio = true;
        }
        break;
      case EnumTresPuntos.Responsables:
        if (newValor.Responsable !== oldValor.Responsable) {
          cambio = true;
        }
        if (newValor.NombreResponsable !== oldValor.NombreResponsable) {
          cambio = true;
        }
        if (newValor.CargoResponsable !== oldValor.CargoResponsable) {
          cambio = true;
        }
        if (newValor.TelefonoResponsable !== oldValor.TelefonoResponsable) {
          cambio = true;
        }
        if (newValor.MailResponsable !== oldValor.MailResponsable) {
          cambio = true;
        }
        break;
      case EnumTresPuntos.TiposDeInsumo:
        if (newValor.TipoInsumo !== oldValor.TipoInsumo) {
          cambio = true;
        }
        if (newValor.DescripcionTipoInsumo !== oldValor.DescripcionTipoInsumo) {
          cambio = true;
        }
        break;
      case EnumTresPuntos.TiposDeLicitaciones:
        if (newValor.TipoLicitacion !== oldValor.TipoLicitacion) {
          cambio = true;
        }
        if (newValor.DescripcionTipoLicitacion !== oldValor.DescripcionTipoLicitacion) {
          cambio = true;
        }
        break;
      case EnumTresPuntos.Unidades:
        if (newValor.Unidad !== oldValor.Unidad) {
          cambio = true;
        }
        if (newValor.DescripcionUnidad !== oldValor.DescripcionUnidad) {
          cambio = true;
        }
        break;
      case EnumTresPuntos.Vendedores:
        if (newValor.Vendedor !== oldValor.Vendedor) {
          cambio = true;
        }
        if (newValor.CargoVendedor !== oldValor.CargoVendedor) {
          cambio = true;
        }
        if (newValor.MailVendedor !== oldValor.MailVendedor) {
          cambio = true;
        }
        if (newValor.NombreVendedor !== oldValor.NombreVendedor) {
          cambio = true;
        }
        if (newValor.TelefonoVendedor !== oldValor.TelefonoVendedor) {
          cambio = true;
        }
        break;
      case EnumTresPuntos.Region:
        if (newValor.Region !== oldValor.Region) {
          cambio = true;
        }
        if (newValor.DescripcionRegion !== oldValor.DescripcionRegion) {
          cambio = true;
        }
        break;
      case EnumTresPuntos.Calendarios:
        if (newValor.CodigoCalendario !== oldValor.CodigoCalendario) {
          cambio = true;
        }
        if (newValor.DescripcionCalendario !== oldValor.DescripcionCalendario) {
          cambio = true;
        }
        if (newValor.Lunes !== oldValor.Lunes) {
          cambio = true;
        }
        if (newValor.Martes !== oldValor.Martes) {
          cambio = true;
        }
        if (newValor.Miercoles !== oldValor.Miercoles) {
          cambio = true;
        }
        if (newValor.Jueves !== oldValor.Jueves) {
          cambio = true;
        }
        if (newValor.Viernes !== oldValor.Viernes) {
          cambio = true;
        }
        if (newValor.Sabado !== oldValor.Sabado) {
          cambio = true;
        }
        if (newValor.Domingo !== oldValor.Domingo) {
          cambio = true;
        }
        if (newValor.Predeterminado !== oldValor.Predeterminado) {
          cambio = true;
        }
        break;
    }

    return cambio;
  }

  public async obtenerCatalogo(offset: number, servicio: string, idPpto?: bigint) {
    const objPeticion: ClsPeticionConsultarGralsCatalogos = new ClsPeticionConsultarGralsCatalogos();
    this.offset = offset;
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
    // solo se manda IdPresupuesto para obtener los programas de obras
    objPeticion.IdPresupuesto = idPpto ?? ClsUtil.getPptoSelectedActivoMaestro(this.infPpto)?.IdPresupuesto;
    objPeticion.Limit = this.gLimiteRegistro;
    objPeticion.Offset = this.offset * this.gLimiteRegistro; // se incrimenta en base el limite
    try {
      const respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, servicio);
      // modo offline
      if (!respuesta) {
        return [];
      }
      const resp = ClsUtil.parseJSONBig(respuesta);
      if (resp?.Errores?.ErrorDescripcion !== '') {
        throw new Error(resp.Errores.ErrorDescripcion);
      }
      this.dataCatalogo = this.dataCatalogo.concat(resp.LsCatalogo ?? []);
      // si length es igual a limite(30,000) posiblemente hay mas datos para obtener
      // si no es es igual, regresar resultado
      if (this.dataCatalogo.length === this.gLimiteRegistro) {
        this.offset++;
        await this.obtenerCatalogo(this.offset, servicio);
      } else {
        return this.dataCatalogo;
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  public async agregarModificarCatalogo(objAddUpdate: any[], servicio: string, unRegistro = true): Promise<any> {
    const objPeticion: ClsPeticionRegistraActualizaGralsCatalogos = new ClsPeticionRegistraActualizaGralsCatalogos();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.Catalogo = objAddUpdate;
    try {
      const respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, servicio)
      // modo offline
      if (!respuesta) {
        return null;
      }
      const addUpdate: ClsRespuestaRegistraActualizaGralsCatalogos = ClsUtil.parseJSONBig(respuesta);
      if (addUpdate?.Errores?.ErrorDescripcion !== '') {
        throw new Error(addUpdate.Errores.ErrorDescripcion);
      }
      return unRegistro ? addUpdate.ListaIds[0] : addUpdate.ListaIdsCodigo;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async eliminarCatalogo(idEliminar: any, servicio: string) {
    const objPeticion: ClsPeticionEliminarGralsCatalogos = new ClsPeticionEliminarGralsCatalogos();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.ListaIds = [idEliminar];
    try {
      const respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, servicio);
      // modo offline
      if (!respuesta) {
        return;
      }
      const eliminar: ClsErrores = ClsUtil.parseJSONBig(respuesta);
      if (eliminar?.ErrorDescripcion !== '') {
        throw new Error(eliminar.ErrorDescripcion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public crearObjCatalogos(data: any, allValores: string[], allColumnas: string[], cat: EnumTresPuntos, objGenerico: ClsObjGenerico): any {
    let obj: any;
    let esNuevo: boolean;
    try {
      switch (cat) {
        case EnumTresPuntos.Ciudades:
          const valCiu: string = allValores[0];
          const valDesCiu: string = allValores[1];
          const valEdoCiu: string = allValores[2];
          // buscamos el estado en el pull de registros
          obj = data.find(value => value.Ciudad.toUpperCase() === valCiu);
          // si no existe en pull de registros y se crea el Obj para
          // guardar en el arreglo que se mandara al servicio,
          // si existe, modificamos la descripcion siempre y cuando sea diferente
          if (ClsUtil.esNulo(obj)) {
            obj = {
              IdCiudad: BigInt(0),
              Ciudad: valCiu,
              DescripcionCiudad: valDesCiu,
              CodigoEstado: valEdoCiu,
              Estado: {Estado: valEdoCiu}
            };
            esNuevo = true;
          } else {
            if (valDesCiu !== obj.DescripcionCiudad || valEdoCiu !== obj.NombreEdo) {
              // obj.DescripcionCiudad = valDesCiu;
              obj = {
                IdCiudad: obj.IdCiudad,
                Ciudad: valCiu,
                DescripcionCiudad: valDesCiu,
                CodigoEstado: valEdoCiu,
                Estado: {Estado: valEdoCiu}
              };
              esNuevo = false;
            }
          }
          break;
        case EnumTresPuntos.Clientes:
          const valCli: string = allValores[0];
          const valNomCli: string = allValores[1];
          const valDirCli: string = allValores[2];
          const valCol: string = allValores[3];
          const valCiuCli: string = allValores[4];
          const valCp: string = allValores[5];
          const valTelCli: string = allValores[6];
          const valMailCli: string = allValores[7];
          // buscamos el estado en el pull de registros
          obj = data.find(value => value.Cliente.toUpperCase() === valCli);
          // si no existe en pull de registros y se crea el Obj para
          // guardar en el arreglo que se mandara al servicio,
          // si existe, modificamos la descripcion siempre y cuando sea diferente
          if (ClsUtil.esNulo(obj)) {
            obj = {
              IdCliente: BigInt(0), Cliente: valCli,
              NombreCliente: valNomCli, DireccionCliente: valDirCli,
              ColoniaCliente: valCol, DescripcionCiudadCliente: valCiuCli,
              CodigoPostalCliente: valCp, TelefonoCliente: valTelCli, MailCliente: valMailCli,
              Ciudad: {Ciudad: valCiuCli}
            };
            esNuevo = true;
          } else {
            if (valCli !== obj.Cliente || valNomCli !== obj.NombreCliente || valDirCli !== obj.DireccionCliente
              || valCol !== obj.ColoniaCliente || valCiuCli !== obj.DescripcionCiudadCliente || valCp !== obj.CodigoPostalCliente
              || valTelCli !== obj.TelefonoCliente || valMailCli !== obj.MailCliente) {
              obj = {
                IdCliente: obj.IdCliente, Cliente: valCli,
                NombreCliente: valNomCli, DireccionCliente: valDirCli,
                ColoniaCliente: valCol, DescripcionCiudadCliente: valCiuCli,
                CodigoPostalCliente: valCp, TelefonoCliente: valTelCli, MailCliente: valMailCli,
                Ciudad: {Ciudad: valCiuCli}
              };
              esNuevo = false;
            }
          }
          break;
        case EnumTresPuntos.ContactoCliente:

          break;
        case EnumTresPuntos.Empresas:
          // buscamos el estado en el pull de registros
          obj = data.find(value => value.Empresa.toUpperCase() === allValores[0]);
          // si no existe en pull de registros y se crea el Obj para
          // guardar en el arreglo que se mandara al servicio,
          // si existe, modificamos la descripcion siempre y cuando sea diferente
          if (ClsUtil.esNulo(obj)) {
            obj = {
              IdEmpresa: BigInt(0), Empresa: allValores[0],
              RazonSocialEmpresa: allValores[1], DescripcionCiudad: allValores[2],
              DireccionEmpresa: allValores[3], Colonia: allValores[4],
              NombreResponsable: allValores[5], TelefonoEmpresa: allValores[6], RfcEmpresa: allValores[7],
              CodigoPostalEmpresa: allValores[8], CMICEmpresa: allValores[9], FaxEmpresa: allValores[10],
              IMSSEmpresa: allValores[11], InfonavitEmpresa: allValores[12], MailEmpresa: allValores[13],
              SitioWeb: allValores[14], Ciudad: {Ciudad: allValores[2]}, Responsable: {Responsable: allValores[5]}
            };
            esNuevo = true;
          } else {
            if (allValores[0] !== obj.Empresa || allValores[1] !== obj.RazonSocialEmpresa || allValores[2] !== obj.DescripcionCiudad
              || allValores[3] !== obj.DireccionEmpresa || allValores[4] !== obj.Colonia || allValores[5] !== obj.NombreResponsable
              || allValores[6] !== obj.TelefonoEmpresa || allValores[7] !== obj.MailEmpresa
              || allValores[8] !== obj.IMSSEmpresa || allValores[9] !== obj.CMICEmpresa
              || allValores[10] !== obj.InfonavitEmpresa || allValores[11] !== obj.FaxEmpresa
              || allValores[12] !== obj.RfcEmpresa || allValores[13] !== obj.CodigoPostalEmpresa
              || allValores[14] !== obj.SitioWeb) {
              obj = {
                IdEmpresa: obj.IdEmpresa, Empresa: allValores[0],
                RazonSocialEmpresa: allValores[1], DescripcionCiudad: allValores[2],
                DireccionEmpresa: allValores[3], Colonia: allValores[4],
                NombreResponsable: allValores[5], TelefonoEmpresa: allValores[6], RfcEmpresa: allValores[7],
                CodigoPostalEmpresa: allValores[8], CMICEmpresa: allValores[9], FaxEmpresa: allValores[10],
                IMSSEmpresa: allValores[11], InfonavitEmpresa: allValores[12], MailEmpresa: allValores[13],
                SitioWeb: allValores[14], Ciudad: {Ciudad: allValores[2]}, Responsable: {Responsable: allValores[5]}
              };
              esNuevo = false;
            }
          }
          break;
        case EnumTresPuntos.Estados:
          const valEdo: string = allValores[0];
          const valNomEdo: string = allValores[1];
          // buscamos el estado en el pull de registros
          obj = data.find(value => value.Estado.toUpperCase() === valEdo);
          // si no existe en pull de registros y se crea el Obj para
          // guardar en el arreglo que se mandara al servicio,
          // si existe, modificamos la descripcion siempre y cuando sea diferente
          if (ClsUtil.esNulo(obj)) {
            obj = {IdEstado: BigInt(0), Estado: valEdo, NombreEstado: valNomEdo};
            esNuevo = true;
          } else {
            if (valNomEdo !== obj.NombreEstado) {
              obj = {IdEstado: obj.IdEstado, Estado: valEdo, NombreEstado: valNomEdo};
              esNuevo = false;
            }
          }
          break;
        case EnumTresPuntos.Familias:
          const valFam: string = allValores[0];
          const valDesFam: string = allValores[1];
          // buscamos la unidad en el pull de registros
          obj = data.find(value => value.Familia.toUpperCase() === valFam);
          // si no existe en pull de registros y se crea el Obj para
          // guardar en el arreglo que se mandara al servicio,
          // si existe, modificamos la descripcion siempre y cuando sea diferente
          if (ClsUtil.esNulo(obj)) {
            obj = {IdFamilia: BigInt(0), Familia: valFam, DescripcionFamilia: valDesFam};
            esNuevo = true;
          } else {
            if (valDesFam !== obj.DescripcionFamilia) {
              obj.DescripcionFamilia = valDesFam;
              esNuevo = false;
            }
          }
          break;
        case EnumTresPuntos.Proveedores:
          // buscamos el estado en el pull de registros
          obj = data.find(value => value.Proveedor.toUpperCase() === allValores[0]);
          // si no existe en pull de registros y se crea el Obj para
          // guardar en el arreglo que se mandara al servicio,
          // si existe, modificamos la descripcion siempre y cuando sea diferente
          if (ClsUtil.esNulo(obj)) {
            obj = {
              IdProveedor: BigInt(0),
              Proveedor: allValores[0],
              DescripcionCiudad: allValores[1],
              RazonSocial: allValores[2],
              RfcProveedor: allValores[3],
              DireccionProveedor: allValores[4],
              ColoniaProveedor: allValores[5],
              CodigoPostalProveedor: allValores[6],
              TelefonoProveedor: allValores[7],
              FaxProveedor: allValores[8],
              MailProveedor: allValores[9],
              ContactoProveedor: allValores[10],
              ObservacionesProveedor: allValores[11],
              CelularProveedor: allValores[12],
              PaginaWebProveedor: allValores[13],
              ProveedorDefault: allValores[14],
              Ciudad: {Ciudad: allValores[1]}
            };
            esNuevo = true;
          } else {
            if (allValores[0] !== obj.Proveedor || allValores[1] !== obj.DescripcionCiudad || allValores[2] !== obj.RazonSocial
              || allValores[3] !== obj.RfcProveedor || allValores[4] !== obj.DireccionProveedor || allValores[5] !== obj.ColoniaProveedor
              || allValores[6] !== obj.CodigoPostalProveedor || allValores[7] !== obj.TelefonoProveedor
              || allValores[8] !== obj.FaxProveedor || allValores[9] !== obj.MailProveedor
              || allValores[10] !== obj.ContactoProveedor || allValores[11] !== obj.ObservacionesProveedor
              || allValores[12] !== obj.CelularProveedor || allValores[13] !== obj.PaginaWebProveedor
              || allValores[14] !== obj.ProveedorDefault) {
              obj = {
                IdProveedor: obj.IdProveedor,
                Proveedor: allValores[0],
                DescripcionCiudad: allValores[1],
                RazonSocial: allValores[2],
                RfcProveedor: allValores[3],
                DireccionProveedor: allValores[4],
                ColoniaProveedor: allValores[5],
                CodigoPostalProveedor: allValores[6],
                TelefonoProveedor: allValores[7],
                FaxProveedor: allValores[8],
                MailProveedor: allValores[9],
                ContactoProveedor: allValores[10],
                ObservacionesProveedor: allValores[11],
                CelularProveedor: allValores[12],
                PaginaWebProveedor: allValores[13],
                ProveedorDefault: allValores[14],
                Ciudad: {Ciudad: allValores[1]}
              };
              esNuevo = false;
            }
          }
          break;
        case EnumTresPuntos.Responsables:
          const valRes: string = allValores[0];
          const valNom: string = allValores[1];
          const valCar: string = allValores[2];
          const valTel: string = allValores[3];
          const valMail: string = allValores[4];
          // buscamos la unidad en el pull de registros
          obj = data.find(value => value.Responsable.toUpperCase() === valRes);
          // si no existe en pull de registros y se crea el Obj para
          // guardar en el arreglo que se mandara al servicio,
          // si existe, modificamos la descripcion siempre y cuando sea diferente
          if (ClsUtil.esNulo(obj)) {
            obj = {
              IdResponsable: BigInt(0), Responsable: valRes, NombreResponsable: valNom,
              CargoResponsable: valCar, TelefonoResponsable: valTel, MailResponsable: valMail
            };
            esNuevo = true;
          } else {
            if (valRes !== obj.Responsable || valNom !== obj.NombreResponsable || valCar !== obj.CargoResponsable || valTel !== obj.TelefonoResponsable || valMail !== obj.MailResponsable) {
              obj = {
                IdResponsable: obj.IdResponsable, Responsable: valRes, NombreResponsable: valNom,
                CargoResponsable: valCar, TelefonoResponsable: valTel, MailResponsable: valMail
              };
              esNuevo = false;
            }
          }
          break;
        case EnumTresPuntos.TiposDeInsumo:
          const valTipo: string = allValores[0];
          const valDesTipo: string = allValores[1];
          // buscamos la Tipos de insumos en el pull de registros
          obj = data.find(value => value.TipoInsumo === Number(valTipo));
          // si no existe en pull de registros y se crea el Obj para
          // guardar en el arreglo que se mandara al servicio,
          // si existe, modificamos la descripcion siempre y cuando sea diferente
          if (ClsUtil.esNulo(obj)) {
            obj = {IdTipoInsumo: Number(valTipo), TipoInsumo: Number(valTipo), DescripcionTipoInsumo: valDesTipo};
            esNuevo = true;
          } else {
            if (valDesTipo !== obj.DescripcionTipoInsumo) {
              // obj = { IdTipoInsumo: Number(valTipo), TipoInsumo: Number(valTipo), DescripcionTipoInsumo: valDesTipo };
              obj.DescripcionTipoInsumo = valDesTipo;
              esNuevo = false;
            }
          }
          break;
        case EnumTresPuntos.TiposDeLicitaciones:
          const valTipoLic: string = allValores[0];
          const valDesLic: string = allValores[1];
          // buscamos la unidad en el pull de registros
          obj = data.find(value => value.TipoLicitacion.toUpperCase() === valTipoLic);
          // si no existe en pull de registros y se crea el Obj para
          // guardar en el arreglo que se mandara al servicio,
          // si existe, modificamos la descripcion siempre y cuando sea diferente
          if (ClsUtil.esNulo(obj)) {
            obj = {IdTipoLicitacion: BigInt(0), TipoLicitacion: valTipoLic, DescripcionTipoLicitacion: valDesLic};
            esNuevo = true;
          } else {
            if (valTipoLic !== obj.TipoLicitacion || valDesLic !== obj.DescripcionTipoLicitacion) {
              obj.TipoLicitacion = valTipoLic;
              obj.DescripcionTipoLicitacion = valDesLic;
              esNuevo = false;
            }
          }
          break;
        case EnumTresPuntos.Unidades:
          const valUni: string = allValores[0];
          const valDesUni: string = allValores[1];
          // buscamos la unidad en el pull de registros
          obj = data.find(value => value.Unidad.toUpperCase() === valUni);
          // si no existe en pull de registros y se crea el Obj para
          // guardar en el arreglo que se mandara al servicio,
          // si existe, modificamos la descripcion siempre y cuando sea diferente
          if (ClsUtil.esNulo(obj)) {
            obj = {IdUnidad: valUni, Unidad: valUni, DescripcionUnidad: valDesUni};
            esNuevo = true;
          } else {
            if (valDesUni !== obj.DescripcionUnidad) {
              // obj = { IdUnidad: valUni, Unidad: valUni, DescripcionUnidad: valDesUni };
              obj.DescripcionUnidad = valDesUni;
              esNuevo = false;
            }
          }
          break;
        case EnumTresPuntos.Vendedores:
          const valVen: string = allValores[0];
          const valNomVen: string = allValores[1];
          const valCarVen: string = allValores[2];
          const valTelVen: string = allValores[3];
          const valMailVen: string = allValores[4];
          if (ClsUtil.esNulo(valVen)) {
            throw new Error(objGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_CAMPO').replace('{0}', allColumnas[0]));
          }
          if (ClsUtil.esNulo(valNomVen)) {
            throw new Error(objGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_CAMPO').replace('{0}', allColumnas[1]));
          }
          if (valVen.length > 20) {
            throw new Error(objGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_CAMPO_MAXIMO').replace('{0}', allColumnas[0]).replace('{1}', '20'));
          }
          if (valNomVen.length > 40) {
            throw new Error(objGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_CAMPO_MAXIMO').replace('{0}', allColumnas[1]).replace('{1}', '40'));
          }
          if (valCarVen.length > 40) {
            throw new Error(objGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_CAMPO_MAXIMO').replace('{0}', allColumnas[2]).replace('{1}', '40'));
          }
          if (valTelVen.length > 40) {
            throw new Error(objGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_CAMPO_MAXIMO').replace('{0}', allColumnas[3]).replace('{1}', '40'));
          }
          if (valMailVen.length > 40) {
            throw new Error(objGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_CAMPO_MAXIMO').replace('{0}', allColumnas[4]).replace('{1}', '40'));
          }
          // buscamos la unidad en el pull de registros
          obj = data.find(value => value.Vendedor.toUpperCase() === valVen);
          // si no existe en pull de registros y se crea el Obj para
          // guardar en el arreglo que se mandara al servicio,
          // si existe, modificamos la descripcion siempre y cuando sea diferente
          if (ClsUtil.esNulo(obj)) {
            obj = {
              IdVendedor: BigInt(0),
              Vendedor: valVen,
              NombreVendedor: valNomVen,
              CargoVendedor: valCarVen,
              TelefonoVendedor: valTelVen,
              MailVendedor: valMailVen
            };
            esNuevo = true;
          } else {
            if (valVen !== obj.Vendedor || valNomVen !== obj.NombreVendedor || valCarVen !== obj.CargoVendedor || valTelVen !== obj.TelefonoVendedor || valMailVen !== obj.MailVendedor) {
              obj.Vendedor = valVen;
              obj.NombreVendedor = valNomVen;
              obj.CargoVendedor = valCarVen;
              obj.TelefonoVendedor = valTelVen;
              obj.MailVendedor = valMailVen;
              esNuevo = false;
            }
          }
          break;
        case EnumTresPuntos.Region:
          const valReg: string = allValores[0];
          const valDesReg: string = allValores[1];
          // buscamos la unidad en el pull de registros
          obj = data.find(value => value.Region.toUpperCase() === valReg);
          // si no existe en pull de registros y se crea el Obj para
          // guardar en el arreglo que se mandara al servicio,
          // si existe, modificamos la descripcion siempre y cuando sea diferente
          if (ClsUtil.esNulo(obj)) {
            obj = {IdRegion: valReg, Region: valReg, DescripcionRegion: valDesReg};
            esNuevo = true;
          } else {
            if (valDesReg !== obj.DescripcionRegion) {
              obj = {IdRegion: obj.IdRegion, Region: valReg, DescripcionRegion: valDesReg};
              esNuevo = false;
            }
          }
          break;
        case EnumTresPuntos.Materiales:
          // buscamos el material en el pull de registros
          obj = data.find(value => value.Codigo.toUpperCase() === allValores[1]);
          // si no existe en pull de registros y se crea el Obj para
          // guardar en el arreglo que se mandara al servicio,
          // si existe, modificamos la descripcion siempre y cuando sea diferente
          if (ClsUtil.esNulo(obj)) {
            obj = {
              IdProveedor: BigInt(0),
              Proveedor: allValores[0],
              DescripcionCiudad: allValores[1],
              RazonSocial: allValores[2],
              RfcProveedor: allValores[3],
              DireccionProveedor: allValores[4],
              ColoniaProveedor: allValores[5],
              CodigoPostalProveedor: allValores[6],
              TelefonoProveedor: allValores[7],
              FaxProveedor: allValores[8],
              MailProveedor: allValores[9],
              ContactoProveedor: allValores[10],
              ObservacionesProveedor: allValores[11],
              CelularProveedor: allValores[12],
              PaginaWebProveedor: allValores[13],
              ProveedorDefault: allValores[14],
              Ciudad: {Ciudad: allValores[1]}
            };
            esNuevo = true;
          } else {
            if (allValores[0] !== obj.Proveedor || allValores[1] !== obj.DescripcionCiudad || allValores[2] !== obj.RazonSocial
              || allValores[3] !== obj.RfcProveedor || allValores[4] !== obj.DireccionProveedor || allValores[5] !== obj.ColoniaProveedor
              || allValores[6] !== obj.CodigoPostalProveedor || allValores[7] !== obj.TelefonoProveedor
              || allValores[8] !== obj.FaxProveedor || allValores[9] !== obj.MailProveedor
              || allValores[10] !== obj.ContactoProveedor || allValores[11] !== obj.ObservacionesProveedor
              || allValores[12] !== obj.CelularProveedor || allValores[13] !== obj.PaginaWebProveedor
              || allValores[14] !== obj.ProveedorDefault) {
              obj = {
                IdProveedor: obj.IdProveedor,
                Proveedor: allValores[0],
                DescripcionCiudad: allValores[1],
                RazonSocial: allValores[2],
                RfcProveedor: allValores[3],
                DireccionProveedor: allValores[4],
                ColoniaProveedor: allValores[5],
                CodigoPostalProveedor: allValores[6],
                TelefonoProveedor: allValores[7],
                FaxProveedor: allValores[8],
                MailProveedor: allValores[9],
                ContactoProveedor: allValores[10],
                ObservacionesProveedor: allValores[11],
                CelularProveedor: allValores[12],
                PaginaWebProveedor: allValores[13],
                ProveedorDefault: allValores[14],
                Ciudad: {Ciudad: allValores[1]}
              };
              esNuevo = false;
            }
          }
          break;
        case EnumTresPuntos.Calendarios:
            const calendario = new ClsCalendario();
            calendario.IdCalendario = BigInt(0);
            calendario.CodigoCalendario = allValores[0];
            calendario.DescripcionCalendario = allValores[1];
            calendario.Lunes = allValores[2] === 'true';
            calendario.Martes = allValores[3] === 'true';
            calendario.Miercoles = allValores[4] === 'true';
            calendario.Jueves = allValores[5] === 'true';
            calendario.Viernes = allValores[6] === 'true';
            calendario.Sabado = allValores[7] === 'true';
            calendario.Domingo = allValores[8] === 'true';
            calendario.Predeterminado = allValores[9] === 'true';

            const dataCalendarios = data as ClsCalendario[];
            obj = dataCalendarios.find((value: ClsCalendario) => value.CodigoCalendario.toUpperCase() === calendario.CodigoCalendario.toUpperCase());

          // buscamos el calendario en el pull de registros
          obj = data.find(value => value.Calendario.toUpperCase() === calendario.CodigoCalendario.toUpperCase());
          // si no existe en pull de registros, se crea el Obj para
          // guardar en el arreglo que se mandará al servicio,
          // si existe, modificamos la descripción siempre y cuando sea diferente
          if (ClsUtil.esNulo(obj)) {
            obj = calendario;
            esNuevo = true;
          } else {
              obj = calendario;
              esNuevo = false;
          }
          break;
        case EnumTresPuntos.Fechas:
          const fecha = new ClsCalendarioFecha();
          fecha.IdFecha = 0;
          fecha.FechaNoLaborable = new Date(allValores[0]);
          fecha.Descripcion = allValores[1];


          const dataFechas = data as ClsCalendarioFecha[];
          obj = dataFechas.find((value: ClsCalendarioFecha) => value.FechaNoLaborable == fecha.FechaNoLaborable);

        obj = data.find(value => value.FechaNoLaborable === fecha.FechaNoLaborable);
        // si no existe en pull de registros, se crea el Obj para
        // guardar en el arreglo que se mandará al servicio,
        // si existe, modificamos la descripción siempre y cuando sea diferente
        if (ClsUtil.esNulo(obj)) {
          obj = fecha;
          esNuevo = true;
        } else {
            obj = fecha;
            esNuevo = false;
        }
        break;
      }
    } catch (e) {
      throw new Error(e.message);
    }
    return {esNuevo, obj};
  }
}
